import { listActionTypes } from "../settings/types";

const initialState = {
    pageSize            : 10,
    pageIndex           : 0,
    totalSize           : 0,
    currentPage         : 1,
    listDomainObjects   : null,
    filter              : null,
    reload               : true,
}

const listReducer = (state = initialState, action) => {
    switch (action.type) {
        case listActionTypes.clearState:
            return initialState
        case listActionTypes.tableParams:
            return {
                ...state,
                pageSize: action.payload.pageSize,
                pageIndex: action.payload.pageIndex,
                totalSize: action.payload.totalSize,
                currentPage: action.payload.currentPage
            }
        case listActionTypes.listDomainObjects:
            return {
                ...state,
                listDomainObjects: action.payload
            }
        case listActionTypes.filter:
            return {
                ...state,
                filter: action.payload
            }
        case listActionTypes.addItem: {
            const resultList = state.listDomainObjects.slice()
            resultList.unshift(action.payload)
            return { ...state, listDomainObjects: resultList}
        }
        case listActionTypes.changeItem:{
            const resultList = state.listDomainObjects.slice()
            const index = resultList.findIndex(i => i.id === action.payload.id);
            resultList[index] = action.payload
            return { ...state, listDomainObjects: resultList}
        }
        case listActionTypes.removeItem: {
            console.log(state.listDomainObjects)
            const resultList = state.listDomainObjects.filter( item => item.id !== action.payload)
            console.log(resultList)
            return { ...state, listDomainObjects: resultList}
        }
        case listActionTypes.reload: {
            return { ...state, reload: !state.reload}
        }
        default:
            return state
    }
}

export default listReducer